import HttpService from "./http.service";

class LabelService extends HttpService {

  list = (params) => this.get("label/list", params);

  listByParentLabelId = (params) => this.get("label/list_by_parent", params);

  createLabelsList = (data) => this.post(`common/upload-label`, data);
  // createLabelsList = (data) => this.post(`common/upload-content`, data);

  createNewLabel = (data) => this.post(`label/store`, data);

  editLabel = (id,data) => this.patch(`label/${id}`, data);

  labelServiceList = (params) => this.get("label_service/list", params);

  createLabelService = (params) => this.post("label_service/store", params);
  
  editLabelService = (id,data) => this.patch(`label_service/${id}`, data);

  parentLabelList = (params) => this.get("parent_label/list", params);

  getParentLabelData = (params) => this.get(`parent_label/${params.id}`, params);

  createParentLabel = (data) => this.post(`parent_label/store`, data);

  createOrder = (data) => this.post(`orderRequest`, data);

  licenseLabelService = (params) => this.post("territory/licensed_store", params);

}

export default new LabelService();
